/* hs-eslint ignored failing-rules */
/* eslint-disable react-hooks/exhaustive-deps */

'use es6';

import { createContext, useState, useMemo } from 'react';
import identity from 'transmute/identity';
import isEmpty from 'transmute/isEmpty';
import { Set as ImmutableSet } from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { AssetPermission, AssetPermissionTypes } from '../../../../permissions/assetPermission';
import { ASSIGNMENT_MODES, AssignmentModePropType, PERMISSION_SETTINGS_USES, PermissionSettingsUsesPropType } from '../constants';
import { useUserSelectState } from './useUserSelectState';
import { useTeamSelectState } from './useTeamSelectState';
import { jsx as _jsx } from "react/jsx-runtime";
const INITIAL_STATE = {
  selectedTeamSet: ImmutableSet(),
  selectedUserSet: ImmutableSet(),
  accessLevel: AssetPermission.EDIT,
  assignmentMode: ASSIGNMENT_MODES.EVERYONE
};
export const PermissionSettingsContext = /*#__PURE__*/createContext(Object.assign({}, INITIAL_STATE, {
  use: PERMISSION_SETTINGS_USES.CREATE,
  selectTeam: identity,
  deselectTeam: identity,
  selectUser: identity,
  deselectUser: identity,
  setAccessLevel: identity,
  setAssignmentMode: identity,
  error: null
}));
const checkPermissionSettings = ({
  assignmentMode,
  selectedUserSet,
  selectedTeamSet
}) => {
  const needAtLeastOneEntitySelected = assignmentMode === ASSIGNMENT_MODES.SPECIFIC && isEmpty(selectedUserSet) && isEmpty(selectedTeamSet);
  if (needAtLeastOneEntitySelected) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "reporting-action-components.permissions.specificPartitioning.noEntitySelected"
    });
  }
  return null;
};
const usePermissionModeState = ({
  initialAccessLevel,
  initialAssignmentMode
}) => {
  const [accessLevel, setAccessLevel] = useState(initialAccessLevel);
  const [assignmentMode, setAssignmentMode] = useState(initialAssignmentMode);
  return {
    accessLevel,
    setAccessLevel,
    assignmentMode,
    setAssignmentMode
  };
};
const useEntitySelectionState = ({
  initialUserSet,
  initialTeamSet
}) => {
  const userSelectState = useUserSelectState(initialUserSet);
  const teamSelectState = useTeamSelectState(initialTeamSet);
  return Object.assign({}, userSelectState, teamSelectState);
};
export const PermissionSettingsProvider = props => {
  const {
    use = PERMISSION_SETTINGS_USES.EDIT,
    initialUserSet = INITIAL_STATE.selectedUserSet,
    initialTeamSet = INITIAL_STATE.selectedTeamSet,
    initialAccessLevel = INITIAL_STATE.accessLevel,
    initialAssignmentMode = INITIAL_STATE.assignmentMode
  } = props;
  const entitySelectionState = useEntitySelectionState({
    initialUserSet,
    initialTeamSet
  });
  const permissionModeState = usePermissionModeState({
    initialAccessLevel,
    initialAssignmentMode
  });
  const settingsState = Object.assign({
    use
  }, entitySelectionState, permissionModeState);
  const error = useMemo(() => checkPermissionSettings(settingsState), [settingsState]);
  return /*#__PURE__*/_jsx(PermissionSettingsContext.Provider, {
    value: Object.assign({}, settingsState, {
      error
    }),
    children: props.children
  });
};
PermissionSettingsProvider.propTypes = {
  use: PermissionSettingsUsesPropType,
  initialUserSet: ImmutablePropTypes.set,
  initialTeamSet: ImmutablePropTypes.set,
  initialAccessLevel: PropTypes.oneOf(AssetPermissionTypes),
  initialAssignmentMode: AssignmentModePropType,
  children: PropTypes.any
};